<template>
  <div class="modules-container">
    <el-tabs tab-position="left" type="card" :stretch="true" class="modules-tabs" @tab-click="section_changed"
      v-model="section">
      <el-tab-pane lazy :label="$t('misc.data')" name="data">
        <div class="modules-content" :key="'data-' + section">
          <div class="modules-grid">
            <NavigationIcon v-for="f in l_data" :url="'/' + f.code" icon="bi bi-person-fill" :text="f.txt"
              :key="'data-' + f.code" :type="f.type" />
          </div>
          <el-empty v-if="!l_data || l_data.length === 0" :description="$t('misc.no_items')" />
        </div>
      </el-tab-pane>

      <el-tab-pane lazy :label="$t('misc.settings')" name="settings">
        <div class="modules-content" :key="'settings-' + section">
          <div class="modules-grid">
            <NavigationIcon v-for="f in l_settings" :url="(f.is_singleton ? '/s/' : '/') + f.code"
              icon="bi bi-person-fill" :text="f.txt" :key="'settings-' + f.code" :type="f.type" />
          </div>
          <el-empty v-if="!l_settings || l_settings.length === 0" :description="$t('misc.no_items')" />
        </div>
      </el-tab-pane>

      <el-tab-pane v-if="!store.state.auth.read_only" lazy :label="$t('misc.functions')" name="functions">
        <div class="modules-content" :key="'functions-' + section">
          <div class="modules-grid">
            <NavigationIcon v-for="f in l_functions" :url="'/' + f.code" icon="bi bi-person-fill" :text="f.txt"
              :key="'functions-' + f.code" :type="f.type" />
          </div>
          <el-empty v-if="!l_functions || l_functions.length === 0" :description="$t('misc.no_items')" />
        </div>
      </el-tab-pane>

      <el-tab-pane lazy :label="$t('misc.reports')" name="reports">
        <div class="modules-content" :key="'reports-' + section">
          <div class="modules-grid">
            <NavigationIcon v-for="f in l_reports" :url="f.code" icon="bi bi-person-fill" :text="f.txt"
              :key="'reports-' + f.code" :type="f.type" />
          </div>
          <el-empty v-if="!l_reports || l_reports.length === 0" :description="$t('misc.no_items')" />
        </div>
      </el-tab-pane>

      <el-tab-pane lazy :label="$t('misc.exports')" name="exports">
        <div class="modules-content" :key="'exports-' + section">
          <div class="modules-grid">
            <NavigationIcon v-for="f in l_exports" :url="'/' + f.code" icon="bi bi-person-fill" :text="f.txt"
              :key="'exports-' + f.code" :type="f.type" />
          </div>
          <el-empty v-if="!l_exports || l_exports.length === 0" :description="$t('misc.no_items')" />
        </div>
      </el-tab-pane>

      <el-tab-pane v-if="!store.state.auth.read_only" lazy :label="$t('misc.imports')" name="imports">
        <div class="modules-content" :key="'imports-' + section">
          <div class="modules-grid">
            <NavigationIcon v-for="f in l_imports" :url="'/' + f.code" icon="bi bi-person-fill" :text="f.txt"
              :key="'imports-' + f.code" :type="f.type" />
          </div>
          <el-empty v-if="!l_imports || l_imports.length === 0" :description="$t('misc.no_items')" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { useStore } from 'vuex';
import NavigationIcon from "../components/NavigationIcon.vue";
import { uiHelpers } from "../ui_helpers";
export default {
  components: {
    NavigationIcon,
  },
  name: "Modules",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore()
    const module = route.params.module;
    const section = route.params.section || 'data';
    const {
      getfunctionslist,
      l_data,
      l_settings,
      l_functions,
      l_reports,
      l_exports,
      l_imports
    } = uiHelpers("view");
    getfunctionslist(module);

    const section_changed = (pane) => {
      router.push({ params: { section: pane.props.name } })
    }
    return {
      module,
      l_data,
      l_settings,
      l_functions,
      l_reports,
      l_exports,
      l_imports,
      section,
      section_changed,
      store
    };
  },
};
</script>

<style scoped>
.modules-container {
  /* margin: 10px 0 0 0; */
  height: calc(100vh - 70px);
  width: calc(100vw - 8px);
  overflow: hidden;
}

.modules-tabs {
  height: 100%;
}

.modules-content {
  height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  scroll-behavior: smooth;
}

.modules-content::-webkit-scrollbar {
  width: 8px;
}

.modules-content::-webkit-scrollbar-track {
  background: rgba(142, 180, 209, 0.1);
  border-radius: 4px;
}

.modules-content::-webkit-scrollbar-thumb {
  background: rgba(82, 145, 194, 0.3);
  border-radius: 4px;
  transition: background 0.3s ease;
}

.modules-content::-webkit-scrollbar-thumb:hover {
  background: rgba(82, 145, 194, 0.5);
}

.modules-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

@media (max-width: 768px) {
  .modules-grid {
    gap: 8px;
  }

  .modules-content {
    padding: 12px;
  }
}

@media (min-width: 1920px) {
  .modules-grid {
    gap: 16px;
  }
}

:deep(.el-tabs__header) {
  background: linear-gradient(to bottom, rgba(142, 180, 209, 0.08), rgba(142, 180, 209, 0.04));
  border-right: 1px solid rgba(82, 145, 194, 0.2);
}

:deep(.el-tabs__item) {
  transition: all 0.3s ease;
  font-weight: 500;
}

:deep(.el-tabs__item:hover) {
  background-color: rgba(142, 180, 209, 0.15);
}

:deep(.el-tabs__item.is-active) {
  background-color: rgba(82, 145, 194, 0.2);
  color: #334762;
  font-weight: 600;
}

:deep(.el-empty) {
  padding: 60px 0;
}

:deep(.el-empty__description) {
  color: rgba(51, 71, 98, 0.5);
  font-size: 0.9rem;
}
</style>
